import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button, Card } from '@totalsoft/rocket-ui';
import { PartnerLabel } from '../BrowserStyle';

const BrowserComponentPJ = ({ pjPartners, handleSaveData }) => {
  const [t] = useTranslation();

  return (
    <Grid container flexDirection='column' gap={1} sx={theme => ({ fontFamily: theme.typography.fontFamily })}>
      {pjPartners?.map((value, idx) => {
        return (
          <Card key={value.uniqueId + idx} disablePadding>
            <Grid container alignItems='center' gap={2} height='100%' py={0.5} px={2}>
              <Grid item container width='auto' flexGrow={1}>
                <Grid item xs={12} md={4}>
                  <PartnerLabel>{t('OfferEdit.Client.PJ.PersonalIdentifier')}:</PartnerLabel> <span>{value.uniqueId || ''}</span>
                </Grid>
                <Grid item xs={12} md={4}>
                  <PartnerLabel>{t('OfferEdit.Client.PJ.CompanyName')}:</PartnerLabel> <span>{value.name || ''}</span>
                </Grid>
                <Grid item xs={12} md={4}>
                  <PartnerLabel>{t('OfferEdit.Client.PJ.LegalForm')}:</PartnerLabel> <span>{value.legalForm || ''}</span>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => {
                    handleSaveData(idx);
                  }}
                >
                  {t('Select')}
                </Button>
              </Grid>
            </Grid>
          </Card>
        );
      })}
    </Grid>
  );
};

BrowserComponentPJ.propTypes = {
  pjPartners: PropTypes.array,
  handleSaveData: PropTypes.func.isRequired
};

export default BrowserComponentPJ;
